var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlywireSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "35px",
    viewBox: "0 0 27 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#147BD1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2826101,14.0013866 L14.6331737,11.9529501 L1.79509666,11.9529501 L2.32296613,8.69588817 L15.152947,8.69588817 L15.4023086,7.13920412 C16.1366301,2.60406466 19.2212662,-0.00637470519 23.8992259,1.16908174e-05 L26.469756,-3.55271368e-15 L25.9653654,3.17484881 L23.5567585,3.17005901 C20.9546535,3.16766411 19.468199,4.43696032 18.9986218,7.26932695 L18.768691,8.69588817 L23.7300163,8.69588817 L23.203766,11.9529501 L18.2489176,11.9529501 L15.544801,27.7289449 C14.8080507,32.2608911 11.6764569,34.8553645 6.97097018,34.8497764 L6.70136813,34.8481798 L7.25028761,31.4091056 L7.42597422,31.4075089 C10.0734178,31.4107021 11.4983415,30.3058556 11.9662994,27.4878584 L13.7231656,17.2560537 L0.867277,17.2560537 L1.39514647,14.0005883 L14.2826101,14.0005883 L14.2826101,14.0013866 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlywireSmall);
export default __webpack_public_path__ + "static/media/flywire-small.1889392ce96180a4b140db4628647297.svg";
export { ForwardRef as ReactComponent };